module.exports = __webpack_public_path__ + "de77a722/img/lock-icon.bb9c7166.svg";